import { useState } from "react";
import Card from "@mui/material/Card";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TableVisitProduct from "./TableVisitProduct";

function TopVisitedProduct ({ mostVisitProduct }) {
  return (
    <Card>
      <MDBox display='flex' justifyContent='space-between' alignItems='center' p={3}>
        <MDBox>
          <MDTypography variant='h6' gutterBottom>
            Most Visited Products
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox>
        <TableVisitProduct mostVisitProduct={mostVisitProduct} />
      </MDBox>
    </Card>
  );
}

export default TopVisitedProduct;
